import { changePassword, setError } from '../store/auth'
import { useDispatch, useSelector } from 'react-redux'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import Spinner from '../components/Spinner'
import { useState } from 'react'

const ChangePassword = ({ onHide, show }) => {
  const dispatch = useDispatch()
  const error = useSelector((state) => state.auth.error)
  const isLoading = useSelector((state) => state.auth.isLoading)
  const success = useSelector((state) => state.auth.success)
  const [currentPassword, setCurrentPassword] = useState()
  const [passwordOne, setPasswordOne] = useState()
  const [passwordTwo, setPasswordTwo] = useState()

  const onSubmit = async (e) => {
    e.preventDefault()

    if (passwordOne !== passwordTwo) {
      dispatch(setError('New Password and Confirm New Password do not match'))
    } else {
      await dispatch(changePassword(currentPassword, passwordOne))
      setCurrentPassword('')
      setPasswordOne('')
      setPasswordTwo('')
    }
  }

  return (
    <Modal onHide={onHide} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Change password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label>Current Password</Form.Label>
            <Form.Control
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder='Current Password'
              type='password'
              value={currentPassword}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              onChange={(e) => setPasswordOne(e.target.value)}
              placeholder='New Password'
              type='password'
              value={passwordOne}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              onChange={(e) => setPasswordTwo(e.target.value)}
              placeholder='Confirm New Password'
              type='password'
              value={passwordTwo}
            />
          </Form.Group>
          <Form.Group>
            <Button
              className='btn-block'
              disabled={isLoading}
              type='submit'
              variant='primary'
            >
              {isLoading ? <Spinner /> : 'Submit'}
            </Button>
          </Form.Group>
          <Form.Group>
            {error && <Alert variant='danger'>{error}</Alert>}
            {success && <Alert variant='success'>{success}</Alert>}
          </Form.Group>
        </form>
      </Modal.Body>
    </Modal>
  )
}

ChangePassword.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default ChangePassword
